<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    v-if="this.$store.getters['auth/userStatus']===true"
    placement="bottom-end"
    add-menu-classes="pt-0 pb-0 dropdown-menu-notimessage"
    style="opacity:96%"
  >
    <template #toggler>
      <CHeaderNavLink>
        <img src="@/assets/icons/Notibell2.svg" style="width:25px" class="mt-2" />
      </CHeaderNavLink>
    </template>

    <CDropdownHeader tag="div" class="dropdown-header-notimessage">
      <strong>NOTIFICATIONS</strong>
      <p>
        You have
        <strong>0 Notifications</strong>
      </p>
    </CDropdownHeader>

    <!-- content -->
    <CDropdownItem class="dropdown-item-notimessage">
      <CBadge>
      </CBadge>
    </CDropdownItem>
    <!-- footer -->
    <CDropdownItem class="dropdownfooter-notimessage" style="background-color:#cccc" v-on:click="Getnoti">
      <p class="text-center">SEE ALL</p>
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: "TheHeaderDropdownNotimessage",
  data() {
    return {
      itemsCount: 42
    };
  },
  methods: {
    Getnoti() {
      this.$router.push("MainProfile");
    }
  }
};
</script>

<style>
.dropdown-menu-notimessage {
  border: 0px;
  -webkit-box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.50);
  -moz-box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.50);
  box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.50);
}
.dropdown-header-notimessage {
  backdrop-filter: opacity(20%);
}
</style>

<style scoped>
@fa-font-path: "../font";
.c-icon {
  margin-right: 0.3rem;
}
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");

.dropdown-header-notimessage {
  width: 500px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  font-family: "Roboto";
  color: #000000;
  font-weight: bold;
  font-size: 24px;
  background-color: #cccccc;
  backdrop-filter: blur(50px) !important;
  -webkit-backdrop-filter: blur(50px) !important;
  border: 0px;

  /* opacity: 50%; */
}

.dropdown-header-notimessage p {
  font-family: "Roboto";
  color: #000000;
  font-weight: 300;
  font-size: 14px;
}

.read {
  float: right;
  font-family: "Roboto";
  color: #000000;
  font-weight: bold;
  font-size: 16px;
  margin-top: -3.5em;
}

.dropdownfooter-notimessage {
  color: black;
  height: 50px;
  background-color: #cccccc;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  justify-content: center;
}
.dropdownfooter-notimessage:hover {
  color: #000000;
  justify-content: center;
}

.dropdown-item-notimessage {
  padding-bottom: 0px;
  border: 0px;
}

.dropdown-item-notimessage h1 {
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  font-size: 20px;
  text-align: left;
  margin-left: 0.8em;
}

.dropdownfooter-notimessage {
  color: black;
  height: 50px;
  background-color: #cccccc;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  justify-content: center;
}

.dropdown-menu.show {
  padding-bottom: 0px;
  border: 0px;
}
.dropdown-menu {
  padding-bottom: 0px;
  border: 0px;
}

.dropdown-item-notimessage p {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-size: 16px;
  margin-left: 1em;
  margin-top: 2em;
}

.dropdown-item {
  width: 500px;
  padding-top: 5px;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  border: 0px;
}

.dropdown-item:hover {
  background-color: #ffa800;
  filter: invert(100%);
  color: black !important;
  border: 0px;
}

.dropdownfooter-notimessage {
  font-family: "Roboto";
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  border: 0px;
  justify-content: center;
}

.dropdownfooter-notimessage p {
  margin-top: 0.5em;
  border: 0px;
  justify-content: center;
}

.badge {
  width: 480px;
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.content {
  float: left;
}
.time {
  float: right;
  margin-top: 1em;
}

.right {
  float: left;
}
.noti-bell {
  width: 25px;
}
.dropdown-menu.show {
    display: block;
    border-radius: 20px;
}
/* body
  > div:nth-child(2)
  > div:nth-child(2)
  > header
  > ul:nth-child(4)
  > li.c-header-nav-items.dropdown.show.nav-item
  > div
  > a.dropdown-item.dropdownfooter-notimessage {
  height: 50px;
  background-color: #cccccc;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
} */
</style>